import {normalize, schema, denormalize} from 'normalizr';

const productAttributeValueLanguage = new schema.Entity('productsAttributesValuesLanguages', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {productsAttributesValuesLanguages: [productAttributeValueLanguage]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = productAttributeValueLanguage;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = productAttributeValueLanguage;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default productAttributeValueLanguage;
